import { Typography } from "@mui/material";

export function AboutUs() {
  return (
    <div className="aboutUs">
      <Typography className="aboutUs__title">About Us</Typography>
      <Typography className="aboutUs__content">
        What is Excursion Expert?
        <br />
        Welcome to Excursion Expert – your ultimate companion for creating
        unforgettable travel itineraries! <br />
        <br />
        We know that planning the perfect trip can be overwhelming, with so many
        options to explore and details to consider. That’s why we’re here to
        take the guesswork out of your travel plans, offering a smart, guided
        way to craft personalized itineraries, no matter where your mind wants
        to take you. <br />
        <br />
        At Excursion Expert, we believe travel should be about exploration, not
        stress. Whether you’re a seasoned adventurer or a first-time traveler,
        our platform combines cutting-edge technology with expert
        recommendations to make planning your trip both easy and exciting. With
        curated destinations, local insights, and customizable schedules, we
        ensure that every step of your journey is tailored to your unique
        preferences.
      </Typography>
    </div>
  );
}
